import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { sanitizeFAQ } from '@sv-support-sdk/utils/src/helpers/sanitizeContent';
import Headline from '@sv-support-sdk/ui-components/src/components/Typography/Headline';

import Breadcrumbs from '../../components/Navigation/Breadcrumbs';
import PageContentInner from '../../components/Layout/Page/PageContentInner';
import LoaderFallback from '../../components/Feedback/Loader/LoaderFallback';
import Article from '../../components/Content/Article';

import { $l } from '../../locales';
import { routes } from '../../routing';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import faqActions from '../../store/actions/faq';
import {
  categoryBySlugSelector,
  topicBySlugSelector,
  topicsLoadingByCategorySlugSelector,
} from '../../store/selectors/faq';

const FAQTopic = () => {
  const params = useParams();
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) =>
    topicsLoadingByCategorySlugSelector(state, params.category),
  );
  const topic = useAppSelector((state) =>
    topicBySlugSelector(state, params.category, params.topic),
  );
  const category = useAppSelector((state) => categoryBySlugSelector(state, params.category));

  useEffect(() => {
    dispatch(faqActions.getCategories());
    dispatch(faqActions.getTopics(params.category as string));
  }, [dispatch, params.category]);

  if (loading) {
    return (
      <PageContentInner height="full">
        <LoaderFallback />
      </PageContentInner>
    );
  }

  if (!topic || !category) {
    return null;
  }

  return (
    <PageContentInner>
      <Breadcrumbs
        items={[
          { text: $l('BREADCRUMBS.FAQ'), link: routes.faq },
          { text: category.name, isLast: true },
        ]}
        className="indent-md-bottom"
      />
      <Headline className="indent-xl-bottom">{topic.question}</Headline>
      <Article size="md">
        <div
          dangerouslySetInnerHTML={sanitizeFAQ(topic.answer, {
            noteTitle: $l('HELP_CENTER_TOPIC.NOTE'),
            tipTitle: $l('HELP_CENTER_TOPIC.TIP'),
          })}
        ></div>
      </Article>
    </PageContentInner>
  );
};

export default FAQTopic;
